import React, { FC } from "react";
import { appName } from "../appInfo";
import { AirmontLogoImg } from "shared-ts-ui-airmont";
import { BootPage } from "shared-ts-ui-app-boot";
import { useTranslation } from "react-i18next";

export interface AppBootProps {
  messages?: Array<string>;
  error?: Error;
}

export const AppBootComponent: FC<AppBootProps> = (props) => {
  const { t } = useTranslation("chimney-insights-ts-translations");
  return (
    <BootPage
      appName={appName}
      booting={t("Firing up the application")}
      messages={props.messages}
      error={props.error}
      appIcon={<AirmontLogoImg />}
    />
  );
};
